export const PaymentMessages = {
    SERVICE_LIFT_MESSAGE: 'Service suspension will be lifted when the payment is verified by our systems.',
} as const;
